(function () {
  const STORAGE_KEY = 'rfrb-collection-view-mode';
  const VALID = new Set(['cards', 'list']);

  function getMode() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (VALID.has(stored)) return stored;
    } catch (e) {
      /* ignore */
    }
    return 'cards';
  }

  function setMode(mode) {
    if (!VALID.has(mode)) return;
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* ignore */
    }
    applyMode(mode);
  }

  function applyMode(mode) {
    const grid =
      document.querySelector('#ProductGridContainer ul.product-grid') ||
      document.querySelector('ul.product-grid') ||
      document.getElementById('product-grid');
    if (grid) {
      grid.classList.toggle('product-grid--list', mode === 'list');
      grid.classList.toggle('product-grid--cards', mode !== 'list');
    }

    document.querySelectorAll('.collection-view-toggle__btn').forEach((btn) => {
      const active = btn.getAttribute('data-view-mode') === mode;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function ensurePreview() {
    let root = document.getElementById('ProductListPreview');
    if (root) return root;

    root = document.createElement('div');
    root.id = 'ProductListPreview';
    root.className = 'product-list-preview';
    root.hidden = true;
    root.innerHTML = `
      <button type="button" class="product-list-preview__backdrop" data-preview-close aria-label="Stäng"></button>
      <div class="product-list-preview__dialog" role="dialog" aria-modal="true" aria-labelledby="ProductListPreviewTitle">
        <button type="button" class="product-list-preview__close" data-preview-close aria-label="Stäng">&times;</button>
        <div class="product-list-preview__media">
          <img id="ProductListPreviewImage" alt="" width="600" height="600">
        </div>
        <h2 class="product-list-preview__title" id="ProductListPreviewTitle"></h2>
        <p class="product-list-preview__price" id="ProductListPreviewPrice"></p>
        <div class="product-list-preview__actions">
          <a class="button" id="ProductListPreviewLink" href="#">Visa produkt</a>
        </div>
      </div>
    `;
    document.body.appendChild(root);

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-preview-close]')) closePreview();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) closePreview();
    });

    return root;
  }

  function openPreview(btn) {
    const root = ensurePreview();
    const title = btn.getAttribute('data-product-title') || '';
    const price = btn.getAttribute('data-product-price') || '';
    const url = btn.getAttribute('data-product-url') || '#';
    const image = btn.getAttribute('data-product-image') || '';
    const alt = btn.getAttribute('data-product-image-alt') || title;

    const img = root.querySelector('#ProductListPreviewImage');
    const titleEl = root.querySelector('#ProductListPreviewTitle');
    const priceEl = root.querySelector('#ProductListPreviewPrice');
    const linkEl = root.querySelector('#ProductListPreviewLink');

    titleEl.textContent = title;
    priceEl.textContent = price;
    linkEl.href = url;

    if (image) {
      img.hidden = false;
      img.src = image;
      img.alt = alt;
    } else {
      img.hidden = true;
      img.removeAttribute('src');
    }

    root.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    root.querySelector('[data-preview-close].product-list-preview__close')?.focus();
  }

  function closePreview() {
    const root = document.getElementById('ProductListPreview');
    if (!root) return;
    root.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', (event) => {
    const modeBtn = event.target.closest('.collection-view-toggle__btn');
    if (modeBtn) {
      event.preventDefault();
      setMode(modeBtn.getAttribute('data-view-mode'));
      return;
    }

    const listBtn = event.target.closest('[data-list-preview]');
    if (listBtn) {
      event.preventDefault();
      openPreview(listBtn);
    }
  });

  document.addEventListener('collection:product-grid:updated', () => {
    applyMode(getMode());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyMode(getMode()));
  } else {
    applyMode(getMode());
  }
})();
